import { render, staticRenderFns } from "./DependencyTableDetails.vue?vue&type=template&id=abb0f850&scoped=true&"
import script from "./DependencyTableDetails.vue?vue&type=script&lang=js&"
export * from "./DependencyTableDetails.vue?vue&type=script&lang=js&"
import style0 from "./DependencyTableDetails.vue?vue&type=style&index=0&id=abb0f850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb0f850",
  null
  
)

export default component.exports